import { saveIcon } from '@assets';
import { Box, Grid } from '@atgfr8/atg-ui-tailwind';
import { Tab, TabsComponent } from '@components';
import { Button } from '@components/Button';
import { useParams } from '@solidjs/router';
import {
  ediConfigurationStore,
  getEDIConfiguerationsForCustomer,
  saveEdiConfig,
} from '@store/customers/customerDetails';
import { deepUnwrap } from '@utils/formUtils';
import { isReadonly } from '@utils/utils';
import {
  Match,
  Show,
  Switch,
  createEffect,
  createSignal,
  onMount,
} from 'solid-js';
import { formatDataTestId } from '@utils/dataTestIdFormatter';

import { EDITabSkeleton } from './components';
import EdiConfiguration from './EdiConfiguration';
import FeaturedFlag from './FeaturedFlag';
import Rules from './Rules';
import TenderAutoResponse from './TenderAutoResponse';

const EDI = () => {
  const [activeTab, setActiveTab] = createSignal(0);
  const params = useParams();

  const tabs = ['FEATURES FLAG', 'RULES', 'TENDER AUTO RESPONSE'];
  let previousId = params.id;
  createEffect(async () => {
    if (previousId !== params.id) {
      previousId = params.id;
      params.id && (await getEDIConfiguerationsForCustomer(params.id));
    }
  });

  onMount(async () => {
    params.id && (await getEDIConfiguerationsForCustomer(params.id));
  });

  const onSaveEdiTab = async () => {
    const payload = deepUnwrap(ediConfigurationStore.ediData);
    payload.ediSettings.forEach((i) => (i.customerId = params.id ?? null));
    await saveEdiConfig(payload);
  };

  return (
    <Show when={!ediConfigurationStore.isLoading} fallback={<EDITabSkeleton />}>
      <Box style={{ 'flex-grow': 1 }}>
        <Grid container spacing={1}>
          <Grid item size={{ xs: 12, md: 4 }}>
            <EdiConfiguration />
          </Grid>
          <Grid item size={{ xs: 12, md: 8 }}>
            <Box class="px-[16px]">
              <div class="flex items-center justify-between">
                <TabsComponent
                  border={true}
                  tabStyleClasses="rounded-t-lg  border-b-2 border-[#d1d5db]"
                  tabContainerStyles=" items-center  "
                  activeStyling="bg-[#026EA126] border-b-2 bg-opacity-[15%] shadow-[0px_1px_8px_0px_rgba(0,0,0,0.12),0px_3px_4px_0px_rgba(0,0,0,0.14),0px_3px_3px_-2px_rgba(0,0,0,0.20)] border-b-[#123B50]"
                  tabs={tabs.map((item, i) => (
                    <Tab
                      customStyle={`${
                        activeTab() === i
                          ? 'text-[#123B50]!'
                          : 'text-[#000000]! text-opacity-[60%]!'
                      }`}
                    >
                      {item}
                    </Tab>
                  ))}
                  activeTab={activeTab()}
                  onTabClick={setActiveTab}
                />
                <Button
                  disabled={isReadonly() || ediConfigurationStore.isSaveLoading}
                  isLoading={ediConfigurationStore.isSaveLoading}
                  label="Save"
                  class="bg-[#248670]!"
                  onClick={onSaveEdiTab}
                  startIcon={
                    <img
                      src={saveIcon}
                      alt=""
                      aria-hidden="true"
                      class="w-[16px]!"
                    />
                  }
                  type="button"
                  variant="contained"
                  dataTestId={formatDataTestId('Save', 'button')}
                />
              </div>
              <Switch>
                <Match when={activeTab() === 0}>
                  <FeaturedFlag />
                </Match>
                <Match when={activeTab() === 1}>
                  <Rules />
                </Match>
                <Match when={activeTab() === 2}>
                  <TenderAutoResponse />
                </Match>
              </Switch>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Show>
  );
};

export default EDI;
